import { AppButton } from "Component/core/elements/Buttons";
import styled from "styled-components";

export const AddNewRewardsButton = styled(AppButton)`
  padding-top: 5px;
  padding-bottom: 5px;

  min-width: calc(calc(min(100vw, 1420px) - 5px - 48px) / 6)
`